<template>
	<div class="wrapper">
		<div class="murk">
			<BalanceInfo :title="region === 'global' ? $t('checkout.buy-nx') : $t('add-balance')" show-switch-account />

			<div class="pending-purchase">
				<div class="pending-purchase__header">
					<div class="pending-purchase__header__title">
						{{ $t('checkout.pending-purchase') }}
					</div>
					<div class="pending-purchase__header__message">
						{{ $t('checkout.pending-purchase-desc') }}
					</div>
				</div>

				<div v-if="orderNumber || orderDate" class="pending-purchase__details">
					<div class="order-details">
						<div v-if="orderNumber" class="order-details__row">
							<span>
								{{ $t('checkout.order-number') }}
							</span>
							<span>{{ orderNumber }}</span>
						</div>

						<div v-if="orderDate" class="order-details__row">
							<span>
								{{ $t('date') }}
							</span>
							<span>{{ orderDate }}</span>
						</div>
					</div>
				</div>

				<div class="pending-purchase__action">
					<FormButton class="btn-primary" :label="setButtonText" :button-click="buttonAction"></FormButton>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import BalanceInfo from '@/components/common/balance-info';
import { FormButton } from '@arena/toolkit';
import config from '@/config/environment-config';
import links from '@/config/links';

export default {
	name: 'PurchasePending',
	components: {
		BalanceInfo,
		FormButton,
	},
	props: {
		orderNumber: {
			type: String,
			default: '',
		},
		returnURL: {
			type: String,
			default: null,
		},
		orderDate: {
			type: String,
			default: '',
		},
		errorCode: {
			type: [String, Number],
			default: null,
		},
	},
	data() {
		return {};
	},
	computed: {
		appType() {
			return this.$store.state.appType;
		},
		setButtonText() {
			if (this.appType === 'game') {
				return this.$t('checkout.close-window');
			}
			return this.$t('checkout.make-another-transaction');
		},
		supportLink() {
			return links[this.region].supportLink;
		},
	},
	methods: {
		buttonAction() {
			if (this.appType === 'game') {
				window.close();
			} else if (this.returnURL) {
				this.goto(this.returnURL);
			} else {
				window.location.href = `${config[process.env.VUE_APP_ENV][environment.region].wallet}/${
					this.$i18n.locale
				}/add-balance`;
			}
		},
	},
};
</script>

<style lang="less" scoped>
.pending-purchase {
	display: flex;
	flex-wrap: wrap;
	max-width: 640px;
	margin-top: 50px;
	margin-left: auto;
	margin-right: auto;
	&__header {
		flex: 0 0 100%;
		max-width: 100%;
		text-align: center;
		line-height: 1;
		padding-bottom: 36px;
		border-bottom: 2px solid rgba(#fff, 50%);
		&:before {
			content: '';
			display: block;
			width: 100%;
			height: 100px;
			background-image: url('~@/images/purchase-complete.png');
			background-repeat: no-repeat;
			background-size: contain;
			background-position: center center;
			margin-bottom: 9px;
		}
		&__title {
			font-size: 24px;
			color: #fff;
		}
		&__message {
			padding-top: 28px;
			line-height: 1.2;
		}
	}
	&__details {
		flex: 0 0 100%;
		max-width: 100%;
		border-bottom: 1px solid rgba(#fff, 20%);
		.order-details {
			padding-top: 2px;
			padding-bottom: 18px;
			&__row {
				padding-top: 15px;
				> span {
					display: block;
					&:last-child {
						padding-top: 8px;
						color: #fff;
					}
				}
			}
		}
	}
	&__contacts {
		flex: 0 0 100%;
		max-width: 100%;
		text-align: center;
		padding-top: 32px;
		a {
			text-decoration: underline;
			text-underline-position: under;
			text-transform: capitalize;
			color: inherit;
			&:hover {
				color: #fff;
			}
		}
	}
	&__action {
		display: flex;
		flex-wrap: wrap;
		flex: 0 0 100%;
		max-width: 100%;
		justify-content: center;
		button {
			min-width: 320px;
			width: auto;
			margin-top: 40px;
		}
	}
}

@media (max-width: 599px) {
	.pending-purchase {
		&__header {
			padding-bottom: 17px;
			&__message {
				padding-top: 11px;
			}
		}
		&__action {
			button {
				min-width: 100%;
				width: 100%;
			}
		}
	}
}

@media (min-width: 1024px) {
	.pending-purchase {
		&__details {
			.order-details {
				padding-bottom: 18px;
				display: table;
				&__row {
					display: table-row;
					> span {
						display: table-cell;
						padding-top: 17px;
						&:last-child {
							padding-left: 29px;
							color: #fff;
						}
					}
				}
			}
		}
	}
}
</style>
